import * as React from 'react';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import * as moment from 'moment';
import { fetchApi, JsonResponse } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { IDName } from '../Accounts/Payments';

type Props = {
    Link: ApiLink;
    CloseDialog: () => void;
    RefreshSchedule: () => void;
    ChildName?: string;
    ShowDelete?: boolean;
}

type State = {
    isLoading: boolean;
    schedule: ScheduleData | null;
    instructorId: number | null;
    instructors: IDName[];
}

type ScheduleData = {
    ChildScheduleID: number;
    FacilityName: string;
    StartTime: Date;
    EndTime: Date;
    InstructorId: number | null;
}

export class ScheduleEditModal extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
        schedule: null,
        isLoading: false,
        instructorId: null,
        instructors: []
    };

    this.save = this.save.bind(this);
    this.updateState = this.updateState.bind(this);
    this.delete = this.delete.bind(this);
  }

  public componentWillMount() {
    fetchApi(this.props.Link.Href, {}, this.props.Link.Method)
      .then((response: { Schedule: ScheduleData, Instructors: IDName[] }) => {
        response.Schedule.StartTime = moment(response.Schedule.StartTime).toDate();
        response.Schedule.EndTime = moment(response.Schedule.EndTime).toDate();
        this.setState({ schedule: response.Schedule, instructors: response.Instructors });
      })
  }

  public render() {
    return (<React.Fragment>
        <div className="k-overlay" style={{ zIndex: 10002, opacity: 0.5 }} />
        <div
          role="dialog"
          className="k-widget k-window k-dialog"
          style={{ maxWidth: '90%', left: 0, right: 0, margin: '0 auto' }}>
          <div className="k-window-titlebar k-dialog-titlebar k-header">
            <span className="k-window-title k-dialog-title">Edit Schedule {(this.props.ChildName !== undefined) ? `- ${this.props.ChildName}` : ''}</span>
            <div className="k-window-actions k-dialog-actions">
                {this.state.schedule && this.props.ShowDelete && <React.Fragment>
                    <button id="btnGroupDrop1" type="button" className="btn btn-danger" aria-haspopup="true" aria-expanded="false" onClick={this.delete}>
                        Delete This Schedule
                    </button>
                </React.Fragment>}
              <a
                role="button"
                href="#"
                className="k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close"
                title="Close"
                aria-label="Close"
                onClick={(e) => {
                  this.props.CloseDialog();
                  e.preventDefault();
                }}>
                <span className="k-icon k-i-close" />
              </a>
            </div>
          </div>
            <div data-role="dialog" className="k-content k-window-content k-dialog-content">
                {this.state.isLoading && <LoadingPanel />}
                {this.state.schedule && <div className="k-form">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span>Facility:&nbsp;</span>
                        </div>
                        <p className="input-group-static font-weight-bold">{this.state.schedule.FacilityName}</p>
                    </div>
                    <div className="form-group">
                        <label>Scheduled Start Time</label>
                        <DateTimePicker
                            width={220}
                            format="MM/dd/yyyy hh:mm a"
                            formatPlaceholder="formatPattern"
                            value={this.state.schedule.StartTime}
                            onChange={(e) => this.updateState({ StartTime: e.value })}
                        />
                    </div>
                    <div className="form-group">
                        <label>Scheduled End Time</label>
                        <DateTimePicker
                            width={220}
                            format="MM/dd/yyyy hh:mm a"
                            formatPlaceholder="formatPattern"
                            value={this.state.schedule.EndTime}
                            onChange={(e) => this.updateState({ EndTime: e.value })}
                        />
                    </div>
                    <div className="form-group">
                        <label>Instructor</label>
                        <DropDownList
                            data={this.state.instructors}
                            textField="Name"
                            defaultItem={{ID: 0, Name: "None"}}
                            value={this.state.instructors.find(x => x.ID == this.state.schedule.InstructorId)}
                            onChange={(e) => this.updateState({ InstructorId: e.target.value.ID })}
                        />
                    </div>
                </div>}
            </div>
            <div className="k-button-group k-dialog-buttongroup k-dialog-button-layout-stretched" role="toolbar">
                <button
                    type="button"
                    className="k-button"
                    style={{ width: '50%' }}
                    onClick={(e) => {
                        this.props.CloseDialog();
                        e.preventDefault();
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="k-button k-primary"
                    style={{ width: '50%' }}
                    onClick={this.save}
                >
                    Save
                </button>
            </div>
        </div>
      </React.Fragment>
    );
  }

  private updateState(value: Partial<ScheduleData>) {

    // Match date
    if (value.StartTime) {
        const endTime = this.state.schedule.EndTime;
        value.EndTime = new Date(value.StartTime.getFullYear(), value.StartTime.getMonth(), value.StartTime.getDate(), endTime.getHours(), endTime.getMinutes(), 0, 0);
    } else if (value.EndTime) {
        const startTime = this.state.schedule.StartTime;
        value.StartTime = new Date(value.EndTime.getFullYear(), value.EndTime.getMonth(), value.EndTime.getDate(), startTime.getHours(), startTime.getMinutes(), 0, 0);
    }

    const schedule = Object.assign({}, this.state.schedule, value);
    this.setState({ schedule });
}

  private save() {
    const data = {
        ChildScheduleID: this.state.schedule.ChildScheduleID,
        StartTime: this.state.schedule.StartTime,
        EndTime: this.state.schedule.EndTime,
        InstructorId: this.state.schedule.InstructorId
    }
    this.setState({ isLoading: true })
    fetchApi("api/ChildSchedule/Update", data, "POST")
        .then((response: JsonResponse) => {
            if (response.Success) {
                this.props.RefreshSchedule();
                this.props.CloseDialog();
            } else {
                alert(response.ErrorMessage);
            }
        }).catch(() => {
            alert("Unknown Error Occurred!");
        }).finally(() => {
            this.setState({ isLoading: false });
        });
  }

    private delete() {
        this.setState({ isLoading: true });
        if (confirm("Are you sure you want to delete this schedule?")) {
            fetchApi(`api/ChildSchedule/Delete/${this.state.schedule.ChildScheduleID}`, {}, 'DELETE')
                .then(() => {
                        this.props.RefreshSchedule();
                        this.props.CloseDialog();
                });
        } else {
            this.setState({ isLoading: false });
        }
    }
}
